export const responseDataLakeAccountMapping = '';